import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface SpeciesRegistryState {
    data: [] | null | any;
    totalRecords: number | null;
    totalPages: number | null;
}

const initialState: SpeciesRegistryState = {
    data: null,
    totalRecords: null,
    totalPages: null,
};

export const speciesRegistrySlice = createSlice({
    name: 'SpeciesRegistry',
    initialState,
    reducers: {
        setSpeciesRegistry: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setSpeciesRegistry, reset } = speciesRegistrySlice.actions;
export const getAllSpeciesRegistryDetails = (state: RootState) => state.speciesRegistry.data;
export const getSpeciesRegistryTotalRecords = (state: RootState) => state.speciesRegistry.totalRecords;
export default speciesRegistrySlice.reducer;
